import { useCallback } from 'react'
import { env } from '../../common/util'
import { useZocksQuota } from '../../components/ScopedBlock/hooks'

type EnvClientIdMapping = {
  prod: string
  staging: string
  dev: string
}

interface QuotaGatedApp {
  clientIds: EnvClientIdMapping
  quota: string
}

const QUOTA_GATED_APPS: QuotaGatedApp[] = [
  {
    clientIds: { prod: 'NNoyHGxUso3Euk2ehPV2fg', staging: 'zH34MHNWefWNZuK2j2WEKA', dev: 'L8uToAZBll6kiSVGoQzRhw' },
    quota: 'app.browserExtension.value',
  },
]

const requiredQuotaByClientId = new Map(QUOTA_GATED_APPS.filter(({ clientIds }) => clientIds[env]).map(({ clientIds, quota }) => [clientIds[env], quota]))

export const useAppQuotaGate = () => {
  const { hasQuota, quotaSuccess, isFetching: quotaIsFetching } = useZocksQuota()

  const isAppQuotaSatisfied = useCallback(
    (clientId: string): boolean => {
      const requiredQuota = requiredQuotaByClientId.get(clientId)
      return requiredQuota ? hasQuota(requiredQuota) : true
    },
    [hasQuota],
  )

  return {
    isAppQuotaSatisfied,
    quotaIsFetching,
    quotaSuccess,
  }
}
